import axiosInstanceMock from "./mock/axiosMock";
import axiosInstanceMain from "./axiosInstance";
import { ChatFeedbackRequest, ComparisonRequest, ComparisonResponse, ConnectAgentRequest, ConnectorDetailsResponse, FetchChatsRequest, IEscalateL1ManagerTicketRequest, IGetL1ManagerAssignedTicketsRequest, IGetL1ManagerTicketDetailsRequest, IGetTransitionJourneyDataPayload, IGetTransitionManagerDocumentsRequest, IResolveL1ManagerTicketRequest, ITSMProcessPayload, ITSMProcessResponse, IUploadTransitionManagerDocumentsRequest, MindMapApiResponse, ObservationsPayload, ReportApiResponse, ReportPayload, SmartCausalConfigPayload, SmartCausalConfigResponse, TraceFlowkRequest } from "../interfaces/serviceInterfaces";
import axios from "axios";
import { getTransitionJourneyGetDataParams } from "./transitionJourneyService";
import { AGENTIC_MS_USER_INFO, getCurrentUserSelectedRole, priorityRoutes, ROLES } from "../constants/appConstants";
import { generateSecureId } from "../utlis/transitionUtils";
import { getEnv } from "../utils/envConfig";

const TRANSITION_MANAGER_DOCUMENTS = getEnv('VITE_TRANSITION_MANAGER_DOCUMENTS_URL');
const TRANSITION_MANAGER_UPLOAD_DOCUMENTS = getEnv('VITE_TRANSITION_MANAGER_UPLOAD_DOCUMENTS_URL');
const TRANSITION_MANAGER_FETCH_CHATS = getEnv('VITE_TRANSITION_MANAGER_FETCH_CHATS_URL');
const TRANSITION_MANAGER_FETCH_CHAT_HISTORY = getEnv('VITE_TRANSITION_MANAGER_FETCH_CHAT_HISTORY_URL');
const TRANSITION_MANAGER_AI_AGENT = getEnv('VITE_TRANSITION_MANAGER_AI_AGENT_URL');
const TRANSITION_MANAGER_CHAT_FEEDBACK = getEnv('VITE_TRANSITION_MANAGER_CHAT_FEEDBACK_URL');
const TRANSITION_MANAGER_TRACE_FLOW = getEnv('VITE_TRANSITION_MANAGER_TRACE_FLOW_URL');
const GET_HEAT_MAP = getEnv('VITE_HEAT_MAP_URL');
const GET_AGENT_LIST = getEnv('VITE_AGENT_REPORT_URL');
const GET_METRIC_TABLE = getEnv('VITE_METRIC_TABLE_URL');
const BASE_URL = getEnv('VITE_API_BASE_URL_TRANSITON_MANAGER');
const TRANSITION_QUALITY_AGENT_ENDPOINT = getEnv('VITE_TRANSITION_QUALITY_AGENT_URL');
const SMART_CAUSAL_REPORT_ENDPOINT = getEnv('VITE_SMART_CAUSAL_REPORT_ENDPOINT');
const OBSERVATIONS_ENDPOINT = getEnv('VITE_OBSERVATIONS_ENDPOINT');
const OBSTABLE_ENDPOINT = getEnv('VITE_OBS_TABLE_ENDPOINT');
const GET_UNIQUE_MAIN_CLUSTERS = getEnv('VITE_GET_UNIQUE_MAIN_CLUSTERS_URL');
const GET_SUBCLUSTERS_DATA = getEnv('VITE_GET_SUBCLUSTERS_DATA_URL');
const MINDMAP_ENDPOINT = getEnv('VITE_MINDMAP_ENDPOINT');
const SMART_CAUSAL_COMPARE_ENDPOINT = getEnv('VITE_SMART_CAUSAL_COMPARE_ENDPOINT');
const SMART_CAUSAL_GET_CONFIG_ENDPOINT = getEnv('VITE_SMART_CAUSAL_GET_CONFIG_ENDPOINT');
const SMART_CAUSAL_SAVE_CONFIG_ENDPOINT = getEnv('VITE_SMART_CAUSAL_UPDATE_CONFIG_ENDPOINT');
const IT_MANAGER_GET_CONFIG_ENDPOINT = getEnv('VITE_IT_MANAGER_SMART_CAUSAL_GET_CONFIG_ENDPOINT');
const IT_MANAGER_SAVE_CONFIG_ENDPOINT = getEnv('VITE_IT_MANAGER_SMART_CAUSAL_UPDATE_CONFIG_ENDPOINT');
const SMART_CAUSAL_CONNECTOR_DETAILS_ENDPOINT = getEnv('VITE_SMART_CAUSAL_CONNECTOR_DETAILS_ENDPOINT');
const IT_MANAGER_CONNECTOR_DETAILS_ENDPOINT = getEnv('VITE_IT_MANAGER_CONNECTOR_DETAILS_ENDPOINT');
const SMART_CAUSAL_ITSM_ENDPOINT = getEnv('VITE_SMART_CAUSAL_ITSM_ENDPOINT');

//const axiosInstance = axiosInstanceMock;
const axiosInstance = axiosInstanceMain;

export async function getTransitionManagerDocuments({
    userId,
    pageSize,
    pageNo,
    category,
    type,
    appliedFilters
}: IGetTransitionManagerDocumentsRequest) {
    try {
        return axiosInstance.request({
            method: 'GET',
            url: `${TRANSITION_MANAGER_DOCUMENTS}`,
            params: {
                page_size: pageSize,
                page: pageNo,
                ...appliedFilters
            },
        })
    } catch (error) {
        console.log(error);
    }
};

export async function uploadDocuments({
    userId, files
}: IUploadTransitionManagerDocumentsRequest) {
    const data = new FormData();
    for (let i = 0; i < files.length; i++) {
        const currentFile = files[i];
        if (currentFile) {
            const currentFileName = currentFile.name;
            data.append('files', currentFile);
        }
    }
    try {
        return axiosInstance.request({
            method: 'POST',
            url: `${TRANSITION_MANAGER_UPLOAD_DOCUMENTS}`,
            //url: `${L1_MANAGER_ASSIGNED_TICKETS}`, // for mock,
            headers: {
                "Content-type": "multipart/form-data",
            },
            data: data
        })
    } catch (error) {
        console.log(error);
    }
};

export async function downloadCloudDocument({ downloadUrl }: { downloadUrl: string }) {
    return axios.get(downloadUrl, { responseType: 'blob' });
}

export async function fetchChats({
    user_id,
    pageSize,
    pageNo,
    appliedFilters
}: FetchChatsRequest & { user_id: string; pageSize: number; pageNo: number }) {
    try {
        const params: Record<string, any> = {
            pageSize,
            pageNo,
        };

        if (appliedFilters?.search_text) {
            params.search_text = appliedFilters.search_text;
        }

        if (appliedFilters?.search_column) {
            params.search_column = appliedFilters.search_column;
        }
        return axiosInstance.request({
            method: 'GET',
            url: `${TRANSITION_MANAGER_FETCH_CHATS}`,
            params
        });
    } catch (error) {
        console.log(error);
    }
}

export async function fetchChatHistory({
    thread_id,
}: any) {
    try {
        return axiosInstance.request({
            method: 'GET',
            url: `${TRANSITION_MANAGER_FETCH_CHAT_HISTORY}/${thread_id}`,
        })
    } catch (error) {
        console.log(error);
    }
}

export async function connectAgent({
    prompt,
    user_id
}: ConnectAgentRequest) {
    try {
        return axiosInstance.request({
            method: 'POST',
            url: `${TRANSITION_MANAGER_AI_AGENT}`,
            data: {
                prompt,
                user_id
            }
        })
    } catch (error) {
        console.log(error);
    }
}

export async function sendChatFeedback({
    chatId,
    messageId,
    userId,
    traceId,
    like,
    dislike,
    comment
}: ChatFeedbackRequest) {
    try {
        return axiosInstance.request({
            method: 'POST',
            url: `${TRANSITION_MANAGER_CHAT_FEEDBACK}`,
            data: {
                chat_id: chatId,
                message_id: messageId,
                user_id: userId,
                trace_id: traceId,
                like,
                dislike,
                feedbackComments: comment
            }
        })
    } catch (error) {
        console.log(error);
    }
}

export async function getChatFeedback({
    chatId
}: ChatFeedbackRequest) {
    try {
        return axiosInstance.request({
            method: 'GET',
            url: `${TRANSITION_MANAGER_CHAT_FEEDBACK}/${chatId}`
        })
    } catch (error) {
        console.log(error);
    }
}

export async function triggerTransitionQualityData({
    data
}: any) {
    try {
        if (!TRANSITION_QUALITY_AGENT_ENDPOINT) {
            throw new Error('TRANSITION_QUALITY_AGENT_ENDPOINT is not configured');
        }
        const dataForm = new FormData();
        dataForm.append('invoked_session_id', 'c5130af2-6bb3-11f0-bbf9-0a58a9feac02');
        return axios.post(TRANSITION_QUALITY_AGENT_ENDPOINT, dataForm, {
            headers: {
                "Content-type": "multipart/form-data",
            }
        });
    } catch (error) {
        console.log(error);
    }
}

export async function traceFlowTransistionManager({
    traceId
}: TraceFlowkRequest) {
    try {
        return axiosInstance.request({
            method: 'GET',
            url: `${TRANSITION_MANAGER_TRACE_FLOW}/${traceId}`,
        })
    } catch (error) {
        console.log(error);
    }
}

class APIRequestManager {
    private activeControllers: Set<AbortController>;
    private debounceTimer: ReturnType<typeof setTimeout> | null;

    constructor() {
        this.activeControllers = new Set();
        this.debounceTimer = null;
    }

    addController(controller: AbortController) {
        this.activeControllers.add(controller);
    }

    removeController(controller: AbortController) {
        this.activeControllers.delete(controller);
    }

    cancelAllRequests() {
        this.activeControllers.forEach(controller => {
            try {
                controller.abort();
            } catch (error) {
                console.error('Error aborting controller:', error);
            }
        });
        this.activeControllers.clear();
    }

    clearDebounceTimer() {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = null;
        }
    }

    setDebounceTimer(callback: () => void, delay: number) {
        this.clearDebounceTimer();
        this.debounceTimer = setTimeout(callback, delay);
    }
}

// Separate request managers for different API types to prevent interference
class HeatmapRequestManager extends APIRequestManager {
    private static instance: HeatmapRequestManager;

    static getInstance(): HeatmapRequestManager {
        if (!HeatmapRequestManager.instance) {
            HeatmapRequestManager.instance = new HeatmapRequestManager();
        }
        return HeatmapRequestManager.instance;
    }
}

class MetricsRequestManager extends APIRequestManager {
    private static instance: MetricsRequestManager;

    static getInstance(): MetricsRequestManager {
        if (!MetricsRequestManager.instance) {
            MetricsRequestManager.instance = new MetricsRequestManager();
        }
        return MetricsRequestManager.instance;
    }
}

// Initialize separate managers for each API type
const heatmapRequestManager = HeatmapRequestManager.getInstance();
const metricsRequestManager = MetricsRequestManager.getInstance();

// Helper function to get dynamic user data
export const getDynamicUserData = () => {
    try {
        const userDataString = sessionStorage.getItem(AGENTIC_MS_USER_INFO);
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            return {
                userId: userData.email,
                userName: userData.name,
                userRole: userData.roles?.[0]
            };
        }
    } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
    }

    // Return null if user data is not available
    return null;
};

// Helper function to check if user has IT Manager role or is on IT Manager Dashboard
export const isSupportAnalystRole = () => {
    const userData = getDynamicUserData();
    const latestRole = getCurrentUserSelectedRole();
    const isSupportAnalyst = latestRole === ROLES.SUPPORT_ANALYST;
    return userData?.userRole?.includes(ROLES.SUPPORT_ANALYST) && window.location.pathname.toLowerCase() == priorityRoutes.it_manager.toLowerCase();
};

export async function getHeatMapData(options = {}) {
    // Cancel only heatmap requests and clear debounce timer
    heatmapRequestManager.cancelAllRequests();
    heatmapRequestManager.clearDebounceTimer();

    // Create new AbortController
    const controller = new AbortController();
    heatmapRequestManager.addController(controller);

    const { start_date, end_date, frequency } = options as { start_date?: string; end_date?: string; frequency?: string; };
    const userDetails = getDynamicUserData();

    if (!userDetails) {
        throw new Error('User data not available');
    }

    const payload = {
        user: {
            userId: userDetails.userId,
            userName: userDetails.userName,
            userRole: userDetails.userRole,
        },
        data: {
            start_date: start_date,
            end_date: end_date,
            frequency: frequency
        },
        metadata: {
            threadId: "thread-51013",
            sessionId: "session-51013",
            messageId: "thread-5151013213",
            timestamp: "2024-01-01T00:00:00Z",
            Source: "api",
            user_conversation_history: [],
            messages: [
                [
                    "human",
                    "I need Microsoft Office version Microsoft 365 installed on my workstation.my operating system is Windows",
                ],
            ],
        },
        channel: {
            source: "web",
            channelType: "api",
            device: "browser",
            language: "en",
        },
    };

    try {
        const response = await axiosInstance.request({
            method: 'POST',
            url: `${GET_HEAT_MAP}`,
            data: payload,
            headers: {
                "Content-Type": "application/json"
            },
            signal: controller.signal
        });

        heatmapRequestManager.removeController(controller);
        return response;
    } catch (error) {
        if (axios.isCancel(error)) {
            return null;
        }
        console.error("Error fetching heat map data:", error);
        throw error;
    } finally {
        heatmapRequestManager.removeController(controller);
    }
}

// Cache for agent list data
let agentListCache: { data: any; timestamp: number } | null = null;

export async function getAgentListData(options = {}, bypassCache = false) {

    const userDetails = getDynamicUserData();

    if (!userDetails) {
        throw new Error('User data not available');
    }

    const payload = {
        user: {
            userId: userDetails.userId,
            userName: userDetails.userName,
            userRole: userDetails.userRole,
        },
        data: options,
        metadata: {
            threadId: "thread-51013",
            sessionId: "session-51013",
            messageId: "thread-5151013213",
            timestamp: new Date().toISOString(),
            Source: "api",
            user_conversation_history: [],
            messages: [["human", "List all agents"]]
        },
        channel: {
            source: "web",
            channelType: "api",
            device: "browser",
            language: "en",
        },
    };

    try {
        const response = await axiosInstance.request({
            method: 'POST',
            url: `${GET_AGENT_LIST}`,
            data: payload,
            headers: {
                "Content-Type": "application/json"
            },
            // signal: controller.signal
        });

        // Update cache
        agentListCache = {
            data: response,
            timestamp: Date.now()
        };

        return response;
    } catch (error) {
        if (axios.isCancel(error)) {
            console.log('Agent list data request cancelled');
            return null;
        }
        console.error("Error fetching agent list data:", error);
        throw error;
    } finally {
        // requestManager.removeController(controller);
    }
}

export async function getMetricTableData(options = {}) {
    // Cancel only metrics requests and clear debounce timer
    metricsRequestManager.cancelAllRequests();
    metricsRequestManager.clearDebounceTimer();

    // Create new AbortController
    const controller = new AbortController();
    metricsRequestManager.addController(controller);

    const { agentName, date } = options as { agentName?: string; date?: string; };

    // If no agent is selected, return empty data
    if (!agentName) {
        return [];
    }

    const userDetails = getDynamicUserData();

    if (!userDetails) {
        throw new Error('User data not available');
    }

    const payload = {
        user: {
            userId: userDetails.userId,
            userName: userDetails.userName,
            userRole: userDetails.userRole,
        },
        data: {
            agentname: agentName,
            range: {
                date: date,
            },
        },
        metadata: {
            threadId: "thread-51013",
            sessionId: "session-51013",
            messageId: "thread-5151013213",
            timestamp: new Date().toISOString(),
            Source: "api",
            user_conversation_history: [],
            messages: [["human", `Get metrics for agent ${agentName}`]]
        },
        channel: {
            source: "web",
            channelType: "api",
            device: "browser",
            language: "en",
        },
    };

        try {
        const response = await axiosInstance.request({
            method: 'POST',
            url: `${GET_METRIC_TABLE}`,
            data: payload,
            headers: {
                "Content-Type": "application/json"
            },
            signal: controller.signal
        });

        // Transform the API response
        const transformedData = [];

        if (response.data.response && response.data.response.data) {
            transformedData.push(...response.data.response.data.map((item: any) => ({
                id: generateSecureId(),
                name: "Agent Analysis",
                lastSeen: new Date().toLocaleDateString(),
                times: 1,
                score: item.overall_score,
                dateTime: item.date_time,
                metrics: item.metrics,
                prompt: item.prompt,
                context: item.context,
                answer: item.answer,
                summary: item.summary,
                user_input: item.user_input
            })));
        } else if (Array.isArray(response.data)) {
            transformedData.push(...response.data.map((item) => ({
                id: item.id || generateSecureId(),
                name: item.name || item.agent_name || "Unknown Agent",
                lastSeen: item.last_seen || new Date().toLocaleDateString(),
                times: item.times || item.usage_count || 0,
                score: item.score || item.quality_score || 0,
                avatarUrl: item.avatar_url || undefined,
                prompt: item.prompt,
                context: item.context,
                answer: item.answer,
                summary: item.summary,
                user_input: item.user_input
            })));
        }

        return transformedData;
    } catch (error) {
        if (axios.isCancel(error)) {
            console.log('Metric table data request cancelled');
            return [];
        }
        console.error("Error fetching metric table data:", error);
        throw error;
    } finally {
        metricsRequestManager.removeController(controller);
    }
}


export async function fetchSmartCausalReport(payload: ReportPayload = {
    daterange: "Monthly",
    cmdb_enabled: true,
    cmdb_checkbox: true
}): Promise<ReportApiResponse> {
    try {
        const response = await axiosInstanceMain.request<ReportApiResponse>({
            method: 'POST',
            url: SMART_CAUSAL_REPORT_ENDPOINT,
            data: payload,
            headers: {
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching smart causal report:", error);
        if (axios.isAxiosError(error)) {
            throw new Error(`Failed to fetch smart causal report: ${error.message}`);
        }
        throw error;
    }
}


export async function fetchComparisonData(payload: ComparisonRequest): Promise<ComparisonResponse> {
    try {
        const response = await axiosInstanceMain.request<ComparisonResponse>({
            method: 'POST',
            url: SMART_CAUSAL_COMPARE_ENDPOINT,
            data: payload,
            headers: {
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching comparison data:", error);
        throw error;
    }
}

export async function getConnectorDetails(connectorId: string, userRole: string): Promise<ConnectorDetailsResponse> {
    try {
        const isSupportAnalyst = userRole === ROLES.SUPPORT_ANALYST;

        // Build the URL with connector ID parameter
        const baseUrl = isSupportAnalyst && IT_MANAGER_CONNECTOR_DETAILS_ENDPOINT
            ? IT_MANAGER_CONNECTOR_DETAILS_ENDPOINT
            : SMART_CAUSAL_CONNECTOR_DETAILS_ENDPOINT;

        const url = `${baseUrl}?connector_id=${connectorId}`;

        const response = await axiosInstance.request<ConnectorDetailsResponse>({
            method: 'GET',
            url: url,
            headers: {
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching connector details:", error);
        throw error;
    }
}

export async function saveSmartCausalConfig(
    payload: SmartCausalConfigPayload,
    userRole: string,
    projectId?: string
): Promise<SmartCausalConfigResponse> {
    try {
        const isSupportAnalyst = userRole === ROLES.SUPPORT_ANALYST;

        const requestPayload = {
            ...payload,
            ...(projectId && { project_id: projectId })
        };

        const response = await axiosInstance.request<SmartCausalConfigResponse>({
            ...(!(isSupportAnalyst && IT_MANAGER_SAVE_CONFIG_ENDPOINT) && !SMART_CAUSAL_SAVE_CONFIG_ENDPOINT && { baseURL: BASE_URL }),
            method: 'PUT',
            url: (isSupportAnalyst && IT_MANAGER_SAVE_CONFIG_ENDPOINT)
                ? IT_MANAGER_SAVE_CONFIG_ENDPOINT
                : SMART_CAUSAL_SAVE_CONFIG_ENDPOINT || '/time-interval/update_smart_causal_config',
            data: requestPayload,
            headers: {
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error saving smart causal configuration:", error);
        throw error;
    }
}

export async function getSmartCausalConfig(userRole: string, projectId?: string): Promise<SmartCausalConfigResponse> {
    try {
        const isSupportAnalyst = userRole === ROLES.SUPPORT_ANALYST;
        
        const params: any = {};
        if (projectId) {
            params.project_id = projectId;
        }
        
        const response = await axiosInstance.request<SmartCausalConfigResponse>({
            ...(!(isSupportAnalyst && IT_MANAGER_GET_CONFIG_ENDPOINT) && !SMART_CAUSAL_GET_CONFIG_ENDPOINT && { baseURL: BASE_URL }),
            method: 'GET',
            url: (isSupportAnalyst && IT_MANAGER_GET_CONFIG_ENDPOINT)
                ? IT_MANAGER_GET_CONFIG_ENDPOINT
                : SMART_CAUSAL_GET_CONFIG_ENDPOINT || '/time-interval/get_smart_causal_config',
            params: params,
            headers: {
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching smart causal configuration:", error);
        throw error;
    }
}

export async function triggerITSMProcess(payload: ITSMProcessPayload): Promise<ITSMProcessResponse> {
    try {
        const response = await axiosInstance.request<ITSMProcessResponse>({
            method: 'POST',
            url: SMART_CAUSAL_ITSM_ENDPOINT,
            data: payload,
            headers: {
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error triggering ITSM process:", error);
        throw error;
    }
}


export async function getObservationsData(payload: ObservationsPayload): Promise<any> {
    try {
        const response = await axiosInstanceMain.request<any>({
            method: 'POST',
            url: OBSERVATIONS_ENDPOINT,
            data: payload,
            headers: {
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching smart causal report:", error);
        throw error;
    }
}

export async function getObsTable(projectId?: string) {
    try {
        const payload: any = {};

        if (projectId) {
            payload.project_id = projectId;
        }

        const response = await axiosInstanceMain.request<any>({
            method: 'POST',
            url: OBSTABLE_ENDPOINT,
            ...(projectId && { data: payload }),
            headers: {
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching obs table:", error);
        throw error;
    }
}


export async function getUniqueMainClusters(projectId?: string) {
    try {
        const payload: any = {};

        if (projectId) {
            payload.project_id = projectId;
        }

        const response = await axiosInstanceMain.request<any>({
            method: 'POST',
            url: GET_UNIQUE_MAIN_CLUSTERS,
            ...(projectId && { data: payload }),
            headers: {
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching unique main clusters:", error);
        throw error;
    }
}

export async function getSubClustersData(payload: any, projectId?: string): Promise<any> {
    try {
        const requestPayload = {
            ...payload,
            ...(projectId && { project_id: projectId })
        };

        const response = await axiosInstanceMain.request<any>({
            method: 'POST',
            url: GET_SUBCLUSTERS_DATA,
            data: requestPayload,
            headers: {
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching subclusters data:", error);
        throw error;
    }
}


export async function getMindMapData(payload?: { project_id: string } | null) {
    try {
        const config: any = {
            method: 'POST',
            url: MINDMAP_ENDPOINT,
            headers: {
                "Content-Type": "application/json"
            }
        };

        if (payload) {
            config.data = payload;
        }

        const response = await axiosInstanceMain.request<MindMapApiResponse>(config);
        return response.data;
    } catch (error) {
        console.error("Error fetching smart causal report:", error);
        throw error;
    }
}